import React, { useEffect, useState } from "react";
export const Offcanvas = _ref => {
  let {
    id,
    classes,
    children,
    className = "",
    overflowHidden = false,
    duration
  } = _ref;
  const [isOpen, setIsOpen] = useState(false);
  const offcanvasOptions = ["flip: true", "mode: slide", "overlay: true", duration != null ? "duration: ".concat(duration) : null].filter(Boolean).join("; ");
  useEffect(() => {
    const element = document.getElementById(id);
    if (!element) return;
    UIkit.util.on(element, "beforehide", e => {
      setIsOpen(false);
    });
    UIkit.util.on(element, "beforeshow", e => {
      setIsOpen(true);
    });
  }, []);
  useEffect(() => {
    const element = document.getElementById(id);
    if (!element) return;
    const offcanvasElement = UIkit.offcanvas(element);
    if (isOpen && offcanvasElement) {
      offcanvasElement.show();
    } else if (!isOpen && offcanvasElement) {
      offcanvasElement.hide();
    }
  }, [isOpen]);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    "data-uk-offcanvas": offcanvasOptions
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      overscrollBehavior: "none"
    },
    className: "uk-offcanvas-bar ".concat(overflowHidden ? "uk-overflow-hidden" : "", " ").concat(className ? className : "")
  }, /*#__PURE__*/React.createElement("button", {
    "data-uk-close": true,
    className: "".concat(classes.close_icon, " uk-offcanvas-close"),
    type: "button",
    onClick: () => setIsOpen(false)
  }), children));
};